import { useState } from "react";

import {
  ExternalContainer,
  InternalContainer,
} from "../../../../components/Reusable/Layout";
import { AirtimePlansTable, AirtimePlanSearchFilter } from "./component";
import { CreateAirtimeModal } from "../../Modal/Airtime/CreateAirtimeModal";
import { AirtimePlan, AirtimePlansProps, EditAirTimePlan } from "./types";
import { EditAirtimeModal } from "../../Modal/Airtime/EditAirtimeModal";
import { DeleteAirtimeModal } from "../../Modal/Airtime/DeleteAirtimeModal";

const AirtimePlans: React.FC<AirtimePlansProps> = ({
  airtimePlans,
  loading,
  statusFilter,
  setStatusFilter,
  onAirtimePlanClick,
  searchTerm,
  setSearchTerm,
  categoryFilter,
  setCategoryFilter,
  countryFilter,
  setCountryFilter,
  sortBy,
  setSortBy,
  sortOrder,
  setSortOrder,
}) => {
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedAirtimePlan, setSelectedAirtimePlan] = useState<
    undefined | AirtimePlan
  >(undefined);
  const [airtimePlanId, setAirtimePlanId] = useState<number | null>(null);

  const onEditClick = (airtime: AirtimePlan) => {
    setSelectedAirtimePlan(airtime);
    setIsEditModalOpen(true);
  };

  const onDeleteClick = (id: number) => {
    setAirtimePlanId(id);
    setIsDeleteModalOpen(true);
  };
  return (
    <ExternalContainer>
      <div className="min-h-screen dark:bg-[#FFFFFF1A] w-full max-w-7xl mx-auto px-4 py-6">
        <InternalContainer headerText="Airtime Plans">
          <div className="flex flex-col">
            <AirtimePlanSearchFilter
              onStatusFilter={setStatusFilter}
              searchTerm={searchTerm}
              onSearchChange={setSearchTerm}
              onCreateNewProduct={() => setIsCreateModalOpen(true)}
              categoryFilter={categoryFilter}
              onCategoryFilter={setCategoryFilter}
              countryFilter={countryFilter}
              onCountryFilter={setCountryFilter}
              sortBy={sortBy}
              onSortByChange={setSortBy}
              sortOrder={sortOrder}
              onSortOrderChange={setSortOrder}
            />
            <div className="border border-[#FFFFFF1A] overflow-x-auto">
              <AirtimePlansTable
                airtimePlans={airtimePlans}
                statusFilter={statusFilter}
                searchTerm={searchTerm}
                onAirtimePlanClick={onAirtimePlanClick}
                onEditClick={onEditClick}
                onDeleteClick={onDeleteClick}
                loading={loading}
              />
            </div>
          </div>
        </InternalContainer>
        <CreateAirtimeModal
          isOpen={isCreateModalOpen}
          onClose={() => setIsCreateModalOpen(false)}
        />
        <EditAirtimeModal
          isOpen={isEditModalOpen && selectedAirtimePlan !== undefined}
          airtimePlan={selectedAirtimePlan as EditAirTimePlan | undefined}
          onClose={() => {
            setIsEditModalOpen(false);
            setSelectedAirtimePlan(undefined);
          }}
        />
        <DeleteAirtimeModal
          id={airtimePlanId}
          isOpen={isDeleteModalOpen && airtimePlanId !== null}
          onClose={() => {
            setIsDeleteModalOpen(false);
            setAirtimePlanId(null);
          }}
        />
      </div>
    </ExternalContainer>
  );
};

export default AirtimePlans;
